import { saveAs } from "file-saver";

export const downloadFromUrl = async (url: string): Promise<void> => {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Request failed (${response.status})`);
    }

    const blob = await response.blob();
    const fileName = url.split("/").pop() || "download";
    saveAs(blob, fileName);
};

export const downloadFromUrlWithFallback = async (url: string): Promise<void> => {
    try {
        await downloadFromUrl(url);
    } catch (_error) {
        window.location.assign(url);
    }
};
